export class BackgroundRect {
  constructor(svg, svgAux = null) {
    this.svg = svg;
    this.svgAux = svgAux ? svgAux : svg;
  }

  backgroundRect({ xDates, xCondition, customName, delta = 0, correct = 0 }) {
    const svg = this.svg;
    const svgAux = this.svgAux;
    const bandWidth = svg.x.bandwidth();

    // include group background style
    const bkgrnd = svgAux
      .selectAll(".bkgrnd" + customName)
      .data([xDates])
      .enter()
      .append("g")
      .attr("class", "bkgrnd" + customName);
    bkgrnd
      .selectAll("rect")
      .data(function(d) {
        return d;
      })
      .enter()
      .append("rect")
      .attr("x", function(d) {
        return svg.x(d) + delta;
      })
      .attr("y", 0)
      .attr("height", svg.height)
      .attr("width", bandWidth - 2 * delta + correct)
      .attr("fill", "none")
      .classed("highlight", function(d, i) {
        return xCondition[i] === true;
      });

    return svg;
  }
}
